// Swiper est chargé globalement via Gulp (assets/js/app.js → window.Swiper)
const Swiper = window.Swiper;

export default function initSwiper(uniqueSelector, config) {
	new Swiper(uniqueSelector, config);
}

document.addEventListener('DOMContentLoaded', function() {

	// Fonction pour normaliser la valeur de slidesPerView
	function normalizeSlidesPerView(value, fallback) {
		if (value === 'auto' || value === 0 || value === '0') return 'auto';

		const parsed = parseInt(value, 10);
		return isNaN(parsed) ? fallback : parsed;
	}

    // Sélectionner tous les conteneurs Swiper sur la page
	document.querySelectorAll('.swiper').forEach((container) => {
        const blockId = container.id;

        // Récupérer tous les attributs
        const slidesPerViewRaw = container.dataset.slidesPerView;
        // Convertir en "auto" si 0, sinon parser comme entier
		let slidesPerViewValue;
		if (slidesPerViewRaw === 'auto' || slidesPerViewRaw === '0') {
			slidesPerViewValue = 'auto';
		} else {
			slidesPerViewValue = parseInt(slidesPerViewRaw, 10);
			if (isNaN(slidesPerViewValue)) slidesPerViewValue = 1;
		}
		let speedValue = parseInt(container.dataset.speed, 10);
		if (isNaN(speedValue)) speedValue = 100;
		if (speedValue < 100) speedValue = 100;

		const slides = Array.from(container.querySelectorAll('.swiper-slide'));
		const paginationEl = container.closest('.wp-block-slider')?.querySelector('.swiper-pagination');
		const useThumbs = container.dataset.paginationThumbs === 'true';
		let spaceBetweenValue = parseInt(container.dataset.spaceBetween, 10);
		if (isNaN(spaceBetweenValue)) spaceBetweenValue = 15;
        const loopEnabled = container.dataset.loop === 'true';
		const navigationEnabled = container.dataset.navigation === 'true';
        const rewindEnabled = container.dataset.rewind === 'true';
        const autoplayEnabled = container.dataset.autoplay === 'true';
        let delayValue = parseInt(container.dataset.delay, 10);
		if (isNaN(delayValue) || delayValue < 100) delayValue = 3000;


        // Récupérer et parser la configuration des breakpoints
        let breakpointsConfig = {};
        try {
			let breakpointsData = {};
			try {
				breakpointsData = JSON.parse(container.dataset.breakpoints || '{}');
			} catch (e) {
				breakpointsData = {};
			}
            if (breakpointsData) {
                breakpointsConfig = {
                    // Par défaut mobile (jusqu'à 580px)
                    0: {
						slidesPerView: normalizeSlidesPerView(breakpointsData.mobile, 1),
                        spaceBetween: spaceBetweenValue
                    },
                    // Tablette (580px à 980px)
                    580: {
                        slidesPerView: normalizeSlidesPerView(breakpointsData.tablet, 2),
                        spaceBetween: spaceBetweenValue
                    },
                    // Desktop (980px et plus)
					980: {
						slidesPerView: slidesPerViewValue,
						spaceBetween: spaceBetweenValue
					}
				};
            }
        } catch (e) {
            console.error('Erreur de parsing des breakpoints:', e);
            // Fallback sur les breakpoints de base
            breakpointsConfig = {
                0: { slidesPerView: 1, spaceBetween: spaceBetweenValue },
                580: { slidesPerView: 2, spaceBetween: spaceBetweenValue },
                980: { slidesPerView: slidesPerViewValue, spaceBetween: spaceBetweenValue }
            };
        }

        // Configuration de base du Swiper
        const swiperConfig = {
            slidesPerView: slidesPerViewValue,
            spaceBetween: spaceBetweenValue,
            loop: loopEnabled,
            speed: speedValue,
			rewind: !loopEnabled && rewindEnabled,
            breakpoints: breakpointsConfig,
        };

        // Gérer le défilement automatique
        if (autoplayEnabled) {
            swiperConfig.autoplay = {
                delay: delayValue,
                disableOnInteraction: false
            };
        }

		// Gérer la navigation
		if (navigationEnabled) {

			let parent = container.closest('.wp-block-slider');

			let prev = parent ? parent.querySelector('.swiper-button-prev') : null;
			let next = parent ? parent.querySelector('.swiper-button-next') : null;

			// Fallback : chercher dans wp-block-slider
			if (!prev || !next) {
				const root = container.closest('.wp-block-slider');
				if (root) {
					prev = root.querySelector('.swiper-button-prev');
					next = root.querySelector('.swiper-button-next');
				}
			}

			if (prev && next) {
				swiperConfig.navigation = { prevEl: prev, nextEl: next, addIcons: false };
			}
		}

		// Gérer la pagination
		if (container.dataset.pagination === 'true' && paginationEl) {
			if (useThumbs) {
				// renderBullet utilise la première <img> trouvée dans la slide
				swiperConfig.pagination = {
					el: paginationEl,
					clickable: true,
					renderBullet: (index, className) => {
						const slideEl = container.querySelectorAll('.swiper-slide')[index];
						const img = slideEl ? slideEl.querySelector('img') : null;
						const src = img ? img.getAttribute('src') : '';
						// si src vide, on renvoie une pastille vide pour garder la compatibilité
						return src
							? `<span class="${className}"><img src="${src}" alt="" /></span>`
							: `<span class="${className}"></span>`;
					}
				};
			} else {
				swiperConfig.pagination = { el: paginationEl, clickable: true };
			}
		}

        // Initialiser Swiper
        try {
            const swiper = new Swiper(container, swiperConfig);
        } catch (error) {
            console.error(`Erreur d'initialisation de Swiper sur ${blockId}:`, error);
        }
    });
});
